(() => {
  const selectors = {
    tab: '.productAccordion__contentItem',
    tabTitle: '.productAccordion__contentItemTitle',
    tabBody: '.productAccordion__contentItemBodyText',

    tabActiveClass: 'productAccordion__contentItem--active',
  }
  const tabTitles = document.querySelectorAll(selectors.tabTitle);

  function toggleTab(tabTitle) {
    currentTab = tabTitle.closest(selectors.tab);
    console.log(tabTitle)
    console.log(currentTab)
    currentTabTitle = currentTab.querySelector(selectors.tabTitle);
    currentTabBody = currentTab.querySelector(selectors.tabBody);

    if (currentTab.classList.contains(selectors.tabActiveClass)) {
      currentTab.classList.remove(selectors.tabActiveClass);
      currentTabBody.style.height = '0';
    } else {
      currentTab.classList.add(selectors.tabActiveClass);
      currentTabBody.style.height = `${currentTabBody.scrollHeight}px`;
    }
  }

  tabTitles.forEach(tab => {
    tab.addEventListener('click', (e) => {
      toggleTab(e.currentTarget);
    })
  });
})();
